import { Component, Injectable, ViewChild, OnInit} from '@angular/core';
import { RequestsService } from '../../services/requests.service';
import { ToastService } from '../../services/toast.service';
import { CustomvalidationService } from '../../services/customvalidation.service';
import { ModalComponent, ModalConfig } from '../../_helpers/modal/modal.component'
import { ModalperguntaComponent } from '../../_helpers/modalpergunta/modalpergunta.component'
import { Projeto } from '../../models/projeto.model';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'add-projeto',
  styleUrls: ['./add-projeto.component.scss'],
  templateUrl: "./add-projeto.component.html"
})

export class AddProjetoComponent implements ModalConfig, OnInit {

  projetoForm: FormGroup;
  submitted = false;
  disableSubmit = false;
  public data: string;
  public modalTitle = "Cadastro/Edição de Projeto";
  public modalperguntaTitle = "Tem certeza que gostaria de excluir o Projeto?";
  public closeButtonLabel = "Fechar";

  @ViewChild('modal', { static: true }) private modalComponent: ModalComponent
  @ViewChild('modalpergunta', { static: true }) private modalperguntaComponent: ModalperguntaComponent
  projeto: Projeto = new Projeto();

  constructor(private formBuilder: FormBuilder,
    private requestService: RequestsService,
    private customValidation: CustomvalidationService,
    private toastService: ToastService) { }

  ngOnInit() {
    this.projetoForm = this.formBuilder.group({
      nome: ['', Validators.required],
      idContrato: ['', Validators.required],
      urlImagemLogo: ['']
    })
  }

  get f() { return this.projetoForm.controls; }

  public hideDismissButton() {
    return true;
  }

  async abrir(registro) {
    this.submitted = false;
    this.disableSubmit = false;
    this.projetoForm.markAsUntouched();

    if (registro)
      this.projeto = registro;
      else
      this.projeto = new Projeto();

    return await this.modalComponent.open();
  }

  async delete(id) {
    await this.modalperguntaComponent.open();
    return await this.modalperguntaComponent.continue(this.modalperguntaComponent.isConfirmed);
  }

  async fechar() {
    await this.modalComponent.close();
  }

  salvar() {
    this.submitted = true;

    if (this.projetoForm.invalid) {
      return;
    }

    if (this.projeto.idContrato == null) {
      this.projeto.idContrato = 0;
    }

    this.disableSubmit = true;
    var request = this.projeto.idProjeto > 0 ? this.requestService.updateProjeto(this.projeto) : this.requestService.insertProjeto(this.projeto);

    request.subscribe(rsp => {
        this.fechar();
        this.toastService.showSuccess("Projeto salvo com sucesso.")
    },err => {
        this.disableSubmit = false;
    });

  }


}
